import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/networking4all.webp';
import screenshot_target from '../../../images/letterfunnel/frankleest.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Frank Leest"
      firstname="Frank"
      companyname="Networking4all"
      competition="Xolphin en Openprovider"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/frankleest.js